import isEqual from "lodash/isEqual";
import { TemplateCategory } from "@teaming/common-enums";
import { formFactory } from "@teaming/common-ui";

const debugNamespace = "teaming:common-team:stores:stream:templateForm";

const translationFactory = i18n => ( key, args = {} ) => i18n.global.t( `common-team.stores.templateForm.${ key }`, args );

// eslint-disable-next-line no-unused-vars
const emptyTemplateForm = ( i18n, mergedOptions, mergedReadonlyData ) => ( {
	meetingTemplateId: "",
	name: "",
	description: "",
	category: TemplateCategory.MY_TEMPLATES,
	content: [],
} );

// eslint-disable-next-line no-unused-vars
const touchTemplateForm = ( form, untouchedForm, mergedOptions, mergedReadonlyData ) => {
	const { touchAll: coerce = false, } = mergedOptions;
	return {
		name: coerce || form.name !== untouchedForm.name,
		description: coerce || form.description !== untouchedForm.description,
		category: coerce || form.category !== untouchedForm.category,
		content: coerce || !isEqual( form.content, untouchedForm.content ),
	};
};

// eslint-disable-next-line no-unused-vars
export const validateTemplateForm = ( form, touches, i18n, mergedOptions, mergedReadonlyData ) => {
	const translate = translationFactory( i18n );
	const { categoryOptions = [], } = mergedReadonlyData;

	const errors = {
		name: "",
		category: "",
		content: "",
		teamId: "",
		scope: "",
	};

	if ( touches.name ) {
		if ( !form.name.trim().length ) {
			errors.name = translate( "templateNameMissing" );
		}
	}

	if ( touches.category ) {
		const allCategoryValues = [
			...Object.values( TemplateCategory ),
			...categoryOptions.map( option => option.value ),
		];
		if ( !allCategoryValues.includes( form.category ) ) {
			errors.category = translate( "templateCategoryInvalid" );
		}
	}

	if ( touches.content ) {
		if ( !form.content.length ) {
			errors.content = translate( "templateContentMissing" );
		}
	}

	return errors;
};

const defaultOptions = {
	touchAll: false,
	leadTeamIds: [], // TODO: use later
};

const defaultReadonlyData = {
	categoryOptions: [],
};

const makeForm = formFactory( {
	emptyForm: emptyTemplateForm,
	touchForm: touchTemplateForm,
	validateForm: validateTemplateForm,
	defaultOptions,
	defaultReadonlyData,
	debugNamespace,
} );

export default args => {
	const form = makeForm( args );
	form.isNew = !form.meetingTemplateId;
	return form;
};
